import {
    APPSTATE,
    ARCHIVESTATE,
    HISTORY,
    LAYOUTSTATE,
    LISTS,
    MAILSTATE,
    MODALSTACK,
    MODALSTATE,
    MYMLSTATE,
    PMSTATE,
    ROOMHISTORYSTATE,
    SEARCHSTATE,
    serverSideIdToName,
    serverSideIdToSlug,
    serverSideSessionToID,
    serverSideSlugToID,
    serverSideUsers,
    SETTINGSSTATE,
    SIDEBAR,
    SNAPVIDEOSTATE,
    THROTTLE_TIMERS,
    VIDEOSTATE,
} from '..'
import { Model } from '../../../types/state'
import { getAllWorkerUsersClosure } from '../../actions/loadUser'
import { AppStateType, EventType } from '../../constants/enums'
import { getHeight, getWidth } from '../../utilities/dimensions'
import {
    getRoomsState,
    getScreenState,
    getSlugAndId,
    getState,
    getUser,
} from '../getState'
import {
    minimizeFloatingRoom,
    openFloatingRoom,
    openQuickReply,
    setFloatingPreview,
    updateFloatingRoom,
    updateRoomCalculations,
} from '../modals/state.floater'
import { pubSubSettings } from '../pubSub'
import { callbacks } from '../pubSub/createPubSub'
import {
    pauseSocketConnection,
    resumeSocketConnection,
    updateAppState,
} from '../state.app'
import {
    removePMChatState,
    setPMChatHistoryMessagesState,
    setPMChatNewsState,
    setPMChatOnlyIfMissingState,
    setPMChatTextState,
    setPMChatUniqueState,
} from '../state.pm'
import { pinRoom } from '../state.rooms'
import { AppRouter } from '../state.router'
import {
    createChatRecord,
    emitState,
    setPMActiveIDState,
    setPMBatchLoadingState,
    setPMChatExaustedState,
    setPMChatIntentionallyClosedState,
    setPMChatLoadingState,
    setPMChatOpenState,
    setPMChatUnreadState,
    setPMChatWasPMCommandUsedState,
    setPMExaustedState,
    setPMLoadingState,
    setPMSearchingState,
    setPMUnreadState,
} from './pms'
import { setRoomViewMode } from './rooms'

if (typeof window !== 'undefined') {
    if (window.__MFC_SERVER_SIDE_STATE__) {
        window.__MFC_SERVER_SIDE_STATE__.forEach((state) => {
            const { type, data } = state

            if (type !== EventType.SERVER_SIDE_USER) {
                return
            }

            const { user, isMe } = data as { user: Model; isMe?: boolean }
            const { session, slug, name, id } = user

            if (isMe) {
                serverSideSlugToID['me'] = id
                serverSideIdToSlug[id] = 'me'
            }

            if (slug) {
                serverSideSlugToID[slug] = id
                serverSideIdToSlug[id] = slug
            }

            if (session) {
                serverSideSessionToID[session] = id
            }

            if (name) {
                serverSideIdToName[id] = name
            }

            serverSideUsers[id] = { ...user }
        })
    }
    window.__MFC_APP_WORKER_USERS__ = getAllWorkerUsersClosure()

    window.__PRESERVE_PAGE_STATE__ = {}
    // some functions for conveniently checkings things through the console
    window.__MFC_APP_HELPERS__ = {
        getSlugAndId,
        pinRoom,
        openQuickReply,
        openFloatingRoom,
        updateFloatingRoom,
        setRoomViewMode,
        updateRoomCalculations,
        minimizeFloatingRoom,
        setFloatingPreview,
        setNsfwValue: (blurRadius = 65) =>
            updateAppState(AppStateType.APP, { nsfw: blurRadius }),
        getUser,
        getDimensions: () => [getHeight(), getWidth()],
        getRoomsState,
        getScreenState,
        getState,
        // pubSub,
        callbacks,
    }
    window.__MFC_APP_APPSTATE__ = APPSTATE
    window.__MFC_APP_SOCKET__ = {
        pause: pauseSocketConnection,
        resume: resumeSocketConnection,
    }
    window.__MFC_APP_MESSAGEARCHIVES__ = ARCHIVESTATE
    window.__MFC_APP_LAYOUT__ = LAYOUTSTATE
    window.__MFC_APP_LISTS__ = LISTS
    window.__MFC_APP_MAIL__ = MAILSTATE
    window.__MFC_APP_MODAL__ = MODALSTATE
    window.__MFC_APP_MODAL_STACK__ = MODALSTACK
    window.__MFC_APP_MYML__ = MYMLSTATE
    window.__MFC_APP_MESSAGES__ = {
        PMSTATE,
        createChatRecord,
        emitState,
        setPMChatIntentionallyClosedState,
        setPMChatWasPMCommandUsedState,
        setPMChatHistoryMessagesState,
        setPMChatOnlyIfMissingState,
        setPMChatExaustedState,
        setPMBatchLoadingState,
        setPMChatLoadingState,
        setPMChatUnreadState,
        setPMChatUniqueState,
        setPMSearchingState,
        setPMChatTextState,
        setPMExaustedState,
        setPMChatOpenState,
        setPMChatNewsState,
        setPMActiveIDState,
        setPMLoadingState,
        removePMChatState,
        setPMUnreadState,
    }
    window.__MFC_APP_ROOMHISTORY__ = ROOMHISTORYSTATE
    window.__ROUTER__ = { AppRouter, HISTORY }
    window.__MFC_APP_SEARCH__ = SEARCHSTATE
    window.__MFC_APP_SETTINGS__ = SETTINGSSTATE
    window.__MFC_APP_SIDEBAR__ = SIDEBAR
    window.__MFC_APP_SNAP_VIDEO__ = SNAPVIDEOSTATE
    window.__MFC_APP_THROTTLE_TIMERS__ = THROTTLE_TIMERS
    window.__MFC_APP_VIDEO__ = VIDEOSTATE
    window.__MFC_APP_TEST_TOOLS__ = { pubSubSettings }
}
